import { Route, Routes } from "react-router-dom";
import NotFound from "./componentes/NotFound";
import Portal from "./componentes/PortalInvestigacion";
import PortalInvestigacionLayout from "./componentes/Layout/PortalInvestigacionLayout";
import Ayuda from "./componentes/Ayuda";
import { ProductoPage } from "./pages/Producto/IndexProducto";
import { CertificadosPage } from "./pages/Certificado/IndexCertificados";
import { SolicitarFirmaPage } from "./pages/Certificado/SolicitarFirmaDecano";
import { FormProductoPage } from "./pages/Producto/Formulario";
import { FormConferenciaPage } from "./pages/Producto/FormConferencia";
import { HomePage } from "./pages/Home/Index";
import BusquedaCertificado from "./componentes/Certificados/BusquedaCertificado";
import { UsuariosPage } from "./pages/Usuario/IndexUsuarios";
import { CalendarPage } from "./pages/Calendar/Calendar";
import ComiteEtica from "./componentes/Etica/Etica";
import { BusqScopusPage } from "./pages/Gestion/BusqScopus";
import { BusqProyectoPage } from "./pages/Gestion/BusqProyectos";
import { ErrorLoginPage } from "./pages/Error/ErrorLogin";
import { PeriodoEvaluacionPage } from "./pages/DashBoard/PeriodoIndex";
import { BusqInvestigadorPage } from "./pages/Producto/BusqInvestigador";
import { FormScopusPage } from "./pages/Producto/FormScopus";
import { ProductoScopusPage } from "./pages/Producto/ProductosScopus";
import { SistemaPage } from "./pages/Sistema/IndexSistema";
import { NotFoundPage } from "./pages/Error/ErrorNotFound";
import { UnauthorizedPage } from "./pages/Error/ErrorUnauthorized";
import { ReportePorPersonaPage } from "./pages/Reporte/ReportePorPersona";
import LayoutInterno from "./componentes/Layout/LayoutSidebarInterno";
import { ProyectosAprobadosPage } from "./pages/Proyectos/ProyectosAprobadosPage";
import { FormProductWithProyPage } from "./pages/Producto/FormProductoWithProy";
import { DashBoardOmniProjectsPage } from "./pages/DashBoard/OmniProjects";
import { FormAdjProyectoPage } from "./pages/Producto/AdjuntarProyecto";
import { BusqAdjuntarPage } from "./pages/Producto/BusqAdjuntar";
import { AddColProductoPage } from "./pages/Producto/AddColaboradorProducto";
import { HistorialEventPage } from "./pages/Usuario/HistorialEventos";
import { BusqProductosPage } from "./pages/Producto/BusqProductos";
import ComboTest from "./componentes/Tester/ComboPost";
import { PendientesPage } from "./pages/SolicitudesProyecto/PendientesPage";
import { ItinerarioPage } from "./pages/Proyectos/ItinerarioInvestigacion";
import { AutoresPublicacionPage } from "./pages/DashBoard/AutoresPublicacion";
import { ProyectosInvestigacionPage } from "./pages/DashBoard/ProyectosInvestigacion";
import {SolicitudesAyudantia} from "./pages/Ayudantias/SolicitudesAyudantias";
import { ImportProductoPage } from "./pages/Producto/ImportProductos";
import { ProyectoColaboradorPage } from "./pages/Proyectos/ProyectoColaboradorPage";
import { PatentePage } from "./pages/Home/Patente";

export const AppRouter:React.FC<{}> = () =>{
    return(
        <Routes>
            <Route path='/' element={<LayoutInterno isSecure={false}/>} errorElement={<NotFound />}>          
                <Route index element={<HomePage />} />
                <Route path='ayuda' element={<Ayuda />}/>
                <Route path='MisCertificados' element={<CertificadosPage/>} />
                <Route path='SolicitarFirmaDec' element={<SolicitarFirmaPage />}/>
                <Route path='Usuarios' element= {<UsuariosPage/>} />
                <Route path='Sistema' element= {<SistemaPage/>} /> 
                <Route path='PeriodoEvaluacion' element= {<PeriodoEvaluacionPage/>} />
                {/* <Route path='Patente' element= {<PatentePage/>} /> */}
            </Route>
            <Route path='/Reporte' element={<LayoutInterno isSecure={false}/>} errorElement={<NotFound />}>          
                <Route path='ProyectoPorPersona' element= {<ReportePorPersonaPage/>} />
                <Route path='DashBoardProyectos' element= {<DashBoardOmniProjectsPage/>} />
            </Route>
            <Route path='/Usuario' element={<LayoutInterno isSecure={false}/>} errorElement={<NotFound />}>          
                {/* <Route path='DatosInvestigador' element= {<DatosInvestigadorPage />} /> */}
                <Route path='Historial' element= {<HistorialEventPage />} /> 
            </Route>
            <Route path='/Producto' element={<LayoutInterno isSecure={false}/>} errorElement={<NotFound />}>          
                <Route path='busquedaScopus' element={<BusqScopusPage />}/>
                <Route path='MisProductos' element={<ProductoPage />}/>
                <Route path='formularioproducto/:id' element={<FormProductoPage />} />
                <Route path='conferencia/:idproducto/:id' element={<FormConferenciaPage />}/>
                <Route path='ProductosProyectoEspol/:idproyecto' element={<FormProductWithProyPage />}/>
                <Route path='busquedaporinvestigador' element= {<BusqInvestigadorPage />} />
                <Route path='busquedaProductos' element= {<BusqProductosPage />} />
                <Route path='productoScopus' element={<ProductoScopusPage />}/>
                <Route path='importar/:obj' element={<FormScopusPage />} />
                <Route path='adjuntarProducto/:id' element={<FormAdjProyectoPage />} />
                <Route path='adjuntarporinvestigador' element= {<BusqAdjuntarPage />} />
                <Route path='addColaboradorProducto/:id' element= {<AddColProductoPage />} />
                <Route path='ImportScopus' element={<ImportProductoPage />} />
            </Route>
            <Route path='/Proyecto' element={<LayoutInterno isSecure={false}/>} errorElement={<NotFound />}>
                {/* <Route path=':idPro' element={<ProyectoPage />} />  */}
                <Route path='proyectosAprobados' element={<ProyectosAprobadosPage />} />
                <Route path='busquedaProyectos' element= {<BusqProyectoPage />} />
                <Route path='solicitudes' element={<PendientesPage />} />
                <Route path='itinerario/:idProy' element={<ItinerarioPage />} />
                <Route path='Personal/:idProy' element={<ProyectoColaboradorPage />} />
                {/* <Route path='ayudantia/:idProy' element={<SolicitudAyudanteInvPage />} />  */}
                {/* <Route path='solicitudAyudante' element={<SolicitudAyudanteInvPage />} />  */}
            </Route>
            <Route path='/Dashboard' element={<LayoutInterno isSecure={false}/>} errorElement={<NotFound />}>
                {/* <Route path=':idPro' element={<ProyectoPage />} /> */} 
                <Route path='Proyectos' element={<ProyectosInvestigacionPage />} />
                <Route path='Tablero' element= {<AutoresPublicacionPage />} />
            </Route>
            {/* <Route path='/Solicitudes' element={<LayoutInterno isSecure={false}/>} errorElement={<NotFound />}>
                <Route index element={<PendientesPage />} />
                <Route path='nuevaSolicitud/:idProy' element={<NuevaSolicitudPage />} />
                <Route path='formularioSolicitud/:idSolicitud' element={<SolicitudFormPage />} />
            </Route>  */}
            <Route path= '/Ayudantias' element={<LayoutInterno isSecure={false}/>} errorElement={<NotFound />}>
                    <Route path='solicitudes' element= {< SolicitudesAyudantia/>} />
            </Route>
            <Route path='/Tester' element={<LayoutInterno isSecure={false}/>} errorElement={<NotFound />}>          
                <Route path='consulta' element= {<ComboTest/>} />
            </Route>
            <Route path='/inicio' element={<PortalInvestigacionLayout />} errorElement={<NotFound />} >
                <Route index element={<Portal />}/>
                <Route path='BusquedaCertificado' element={<BusquedaCertificado/>} />
                <Route path='CalendarioInvestigacion' element={<CalendarPage />} />
                <Route path='comite-etica' element={<ComiteEtica />} />
                <Route path='error-login' element={<ErrorLoginPage />} />
                <Route path='unauthorized' element={<UnauthorizedPage />} />
            </Route>
            <Route path='*' element={<NotFoundPage />} />
        </Routes>
    );
}